import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {ResponseListing360} from "../dto/question360.dto";

@Injectable()
export class Question360Api {

  private service: string = '';
  private model: string = 'sf6s/question360';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public history(empId: string, page: number, limit: number): Observable<ResponseListing360> {
    const method: string = 'GET';
    const func: string = 'history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public empData(empId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'empData';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public formHeader(revieweeEmpid: string, periodcode: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'formHeader';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    
    if (typeof revieweeEmpid !== 'undefined' && revieweeEmpid !== null) urlParams.revieweeEmpid = revieweeEmpid;
    if (typeof periodcode !== 'undefined' && periodcode !== null) urlParams.periodcode = periodcode;
    
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public formQuestion(revieweeEmpid: string, periodcode: string, page: number, limit: number): Observable<any> {
    const method: string = 'GET';
    const func: string = 'formQuestion';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    
    if (typeof revieweeEmpid !== 'undefined' && revieweeEmpid !== null) urlParams.revieweeEmpid = revieweeEmpid;
    if (typeof periodcode !== 'undefined' && periodcode !== null) urlParams.periodcode = periodcode;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;
    
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public submit(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "submit";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/question360.api.ts